import React from 'react';
import './Loading.css';

const Loading = ({
  size = 'medium',
  text = 'Loading...',
  overlay = false,
  fullScreen = false
}) => {
  const loadingContent = (
    <div className={`loading loading-${size}`}>
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        {loadingContent}
      </div>
    );
  }

  if (overlay) {
    return (
      <div className="loading-overlay">
        {loadingContent}
      </div>
    );
  }

  return loadingContent;
};

export default Loading;
